import React from 'react';
import { X } from 'lucide-react';
import { Resource } from '../../lib/resources';

interface ResourceHeaderProps {
  resource: Resource;
  onClose: () => void;
}

export default function ResourceHeader({ resource, onClose }: ResourceHeaderProps) {
  return (
    <div className="px-6 py-4 border-b border-[#2f2f2f] flex items-center justify-between bg-[#1a1a1a]">
      <div className="flex items-center space-x-4">
        <button onClick={onClose} className="text-gray-400 hover:text-gray-300">
          <X className="h-5 w-5" />
        </button>
        <div>
          <div className="flex items-center space-x-2">
            <h2 className="text-lg font-semibold text-white">
              {`${resource.first_name} ${resource.last_name}`}
            </h2>
            <span className="text-sm text-gray-400">{resource.id}</span>
          </div>
          <div className="flex items-center mt-0.5">
            <div className="h-1.5 w-1.5 rounded-full bg-green-500 mr-2" />
            <span className="text-sm text-gray-400">Active Employee</span>
          </div>
          {resource.status === 'inactive' && (
            <div className="mt-1 text-sm text-red-400">
              Deactivated
            </div>
          )}
        </div>
      </div>
    </div>
  );
}